import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/NotificationDrawer/notification-drawer';
import { Text, TextVariants } from '../Text';
export var NotificationDrawerHeader = function NotificationDrawerHeader(_a) {
  var children = _a.children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      count = _a.count,
      _a$title = _a.title,
      title = _a$title === void 0 ? 'Notifications' : _a$title,
      _a$unreadText = _a.unreadText,
      unreadText = _a$unreadText === void 0 ? 'unread' : _a$unreadText,
      props = __rest(_a, ["children", "className", "count", "title", "unreadText"]);

  return React.createElement("div", Object.assign({}, props, {
    className: css(styles.notificationDrawerHeader, className)
  }), React.createElement(Text, {
    component: TextVariants.h1,
    className: css(styles.notificationDrawerHeaderTitle)
  }, title), count && React.createElement("span", {
    className: css(styles.notificationDrawerHeaderStatus)
  }, "".concat(count, " ").concat(unreadText)), children && React.createElement("div", {
    className: css(styles.notificationDrawerHeaderAction)
  }, children));
};